import { c } from "react/compiler-runtime";
import { useContext } from "react";
import { PresentationContext, PresentationNavigateContext } from "sanity/_singletons";
import { defineLocaleResourceBundle, getDefaultVariant, usePerspective } from "sanity";
/**
* The locale namespace for the presentation tool
*
* @public
*/
const presentationLocaleNamespace = "presentation", presentationUsEnglishLocaleBundle = defineLocaleResourceBundle({
	locale: "en-US",
	namespace: presentationLocaleNamespace,
	resources: () => import("./resources-BQcJcDAy.js")
});
/**
* The selected editing variant as a bare variant id (e.g. `Ab12cd34`), or `undefined` when no
* variant is selected. This is the raw `variant` router sticky param value, available
* synchronously — orthogonal to the perspective, and passed alongside it wherever the
* perspective travels (iframe URL, comlink messages, loader fetches).
* @internal
*/
function usePresentationVariant() {
	let $ = c(2), { selectedVariantNames } = usePerspective(), t0;
	return $[0] === selectedVariantNames ? t0 = $[1] : (t0 = getDefaultVariant(selectedVariantNames), $[0] = selectedVariantNames, $[1] = t0), t0;
}
function usePresentationTool(t0) {
	let throwOnMissingContext = t0 === void 0 || t0, presentation = useContext(PresentationContext);
	if (throwOnMissingContext && !presentation) throw Error("Presentation context is missing");
	return presentation;
}
/** @public */
function usePresentationNavigate() {
	let navigate = useContext(PresentationNavigateContext);
	if (!navigate) throw Error("Presentation navigate context is missing");
	return navigate;
}
export { presentationUsEnglishLocaleBundle as a, presentationLocaleNamespace as i, usePresentationTool as n, usePresentationVariant as r, usePresentationNavigate as t };

//# sourceMappingURL=usePresentationNavigate-DhoGmkX9.js.map